import { supabase } from '@/integrations/supabase/client';

interface RpcResult { data: unknown; error: unknown }
type LibraryRpc = (
  name: 'list_visible_workout_plans' | 'remove_workout_plan',
  args?: { p_plan_id: string }, options?: { get: boolean },
) => PromiseLike<RpcResult>;

// Bind only when invoked: importing a read-only plan-sequence helper must not
// initialize an unrelated writer or touch an SDK method.
const libraryRpc: LibraryRpc = (name, args, options) =>
  (supabase.rpc.bind(supabase) as unknown as LibraryRpc)(name, args, options);
export const listVisibleWorkoutPlans = () => libraryRpc('list_visible_workout_plans', undefined, { get: true });
export const removeSavedWorkoutPlan = (planId: string) => libraryRpc('remove_workout_plan', { p_plan_id: planId });
